module.exports = __webpack_public_path__ + "static/img/officialQR.ebf498e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/officialQR.png
// module id = KAVW
// module chunks = 101